import {
  PATH_NAME_AGREEMENT,
  PATH_NAME_PAID,
  PATH_NAME_POOQZONE_VOUCHER,
  PATH_NAME_POOQZONE_PRIVACY,
  PATH_NAME_PRIVACY,
  PATH_NAME_SERVICE,
  PATH_NAME_YOUTH
} from '@/common/router.const'

export default [
  {
    path: '/agreement',
    name: PATH_NAME_AGREEMENT,
    components: {
      agreement: () => import('@/views/customer/AgreementView')
    },
    children: [
      {
        path: 'service',
        name: PATH_NAME_SERVICE,
        components: {
          agreementView: () => import('@/components/agreement/CommonAgreement')
        }
      },
      {
        path: 'paid',
        name: PATH_NAME_PAID,
        components: {
          agreementView: () => import('@/components/agreement/CommonAgreement')
        }
      },
      {
        path: 'privacy',
        name: PATH_NAME_PRIVACY,
        components: {
          agreementView: () => import('@/components/agreement/CommonAgreement')
        }
      },
      {
        path: 'youth',
        name: PATH_NAME_YOUTH,
        components: {
          agreementView: () => import('@/components/agreement/CommonAgreement')
        }
      },
      {
        path: 'pooqzone',
        name: PATH_NAME_POOQZONE_VOUCHER,
        components: {
          agreementView: () => import('@/components/agreement/CommonAgreement')
        }
      },
      {
        path: 'pooqzone_privacy',
        name: PATH_NAME_POOQZONE_PRIVACY,
        components: {
          agreementView: () => import('@/components/agreement/CommonAgreement')
        }
      }
    ]
  }
]
